// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppReminderTemplateFormController from "./app_reminder_template_form_controller.js"
application.register("app-reminder-template-form", AppReminderTemplateFormController)

import AutoRefreshPageController from "./auto_refresh_page_controller.js"
application.register("auto-refresh-page", AutoRefreshPageController)

import ImageUploaderController from "./image_uploader_controller.js"
application.register("image-uploader", ImageUploaderController)

import MenuSearchController from "./menu_search_controller.js"
application.register("menu-search", MenuSearchController)
